import React, { Fragment } from "react";
import ProductAddToCart from "../productPage/ProductAddToCart";
import { useSelector, useDispatch } from "react-redux";
import { setUserEntry } from "../../../server/Customer";
import Detailes from "./cardDeailes";
import { Heart } from "lucide-react";

const Card = ({
  element,
  familyProd = true,
  showPrice = true,
  productLocationPopUp,
  productPopUp,
  addToShopListPopUp,
  comparePricesPopUp,
  listHeartActive = false,
}) => {
  const WeightJump = element.weightJump > 0 ? element.weightJump : 1;
  const dispatch = useDispatch();

  const { role, includeInactive } = useSelector((state) => ({
    role: state.user.role,
    includeInactive: state.category.includeInactive,
  }));
  const user = useSelector((state) => state.user.user);
  const showStatusBadge = role && includeInactive && element.status;
  //console.log("element in card:", element, role);

  const inCart = useSelector((state) =>
    state.productsInCart.productsInCart.find(
      (item) => item.productId === element.productId,
    ),
  );

  const AddToShopListIfUser = () => {
    if (!user || localStorage.getItem("userRole").includes("guest")) {
      dispatch(setUserEntry([true, "login"]));
    } else {
      addToShopListPopUp();
    }
  };

  const showCustomerCartRow =
    !role &&
    (element.availability["availableQuantity"] >= WeightJump ||
      (inCart && inCart.quantity > 0));

  const isOutOfStock = !role && !showCustomerCartRow;

  const listCornerButton = showCustomerCartRow ? (
    <button
      type="button"
      className={`item-card-list-btn${listHeartActive ? " item-card-list-btn--active" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        AddToShopListIfUser();
      }}
      data-tip
      data-for="registerTipAddToList"
      aria-label="הוספה לרשימה"
    >
      <Heart
        size={17}
        strokeWidth={1.75}
        aria-hidden
        fill={listHeartActive ? "currentColor" : "none"}
      />
    </button>
  ) : null;

  return (
    <Fragment>
      <div className={role ? "item-card role" : "item-card"}>
        {showStatusBadge ? (
          <span className={`card-status-badge ${element.status}`}>
            {element.status === "ACTIVE" ? "פעיל" : "לא פעיל"}
          </span>
        ) : null}
        {element.weightJump > 1 && (
          <span className="sales-jump tag tag--meta">
            נמכר ב-{element.weightJump} יחידות
          </span>
        )}
        {element.pricing?.promotions?.length > 0 &&
          (element.pricing.promotions[0].promoType === "QUANTITY_PRICE" ? (
            <span className="sales-jump tag tag--sale">
              מבצע {element.pricing.promotions[0].minQuantity} ב-{" "}
              {element.pricing.promotions[0].discountValue}
            </span>
          ) : element.pricing.promotions[0].promoType === "PERCENT" ? (
            <>
              <span className="sales-jump tag tag--sale">מחיר מבצע</span>
              <span className="passover-kashrut tag tag--deal">
                {element.pricing.promotions[0].discountValue}% הנחה
              </span>
            </>
          ) : element.pricing.promotions[0].promoType === "FLAT" ? (
            <span className="sales-jump tag tag--sale">מחיר מבצע</span>
          ) : null)}

        {!role && element.availability["availableQuantity"] === 0 ? (
          <div className="top-card-section">
            <p className="inventoryEnd">חסר</p>
          </div>
        ) : null}

        <Detailes
          element={element}
          familyProd={familyProd}
          showPrice={showPrice}
          inCart={inCart}
          productPopUp={productPopUp}
          comparePricesPopUp={comparePricesPopUp}
          showProductEdit={!!role}
          isStaff={!!role}
          weightJump={WeightJump}
          productLocationPopUp={productLocationPopUp}
          imageCornerActions={listCornerButton}
          footerSlot={
            isOutOfStock ? (
              <div
                className="oos-label"
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "var(--color-soft-surface)",
                  color: "var(--hz-muted)",
                  borderRadius: "10px",
                  fontSize: "14px",
                  cursor: "default",
                  userSelect: "none",
                }}
              >
                חסר במלאי
              </div>
            ) : showCustomerCartRow ? (
              <ProductAddToCart element={element} haveInfo={false} retailCard />
            ) : null
          }
        />

        <div className="details">
          {element.DisableProductId > 1 && element.DisableProductId !== 6 && (
            <p className="inventoryEnd disable-product">
              {element.DisableProduct}
            </p>
          )}

          {element.DisableProductId === 6 && role && (
            <p className="inventoryEnd disable-product">
              {element.DisableProduct}
            </p>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default React.memo(Card);
